import useAccount from '@hooks/useAccount'
import useClientConfig from 'config/clients/useClientConfig'
import dayjs from 'dayjs'
import _ from 'lodash'



const parseSort = (extras: any) => {
  if (extras?.sort === undefined) {
    return undefined
  }

  const sort = extras.sort
  //@ts-ignore
  const sortBy = sort?.['sortBy'] ?? Object.keys(sort)[0] ?? undefined
  //@ts-ignore
  const order = sort?.['value'] ?? sort?.['order'] ?? Object.values(sort)[0] ?? undefined


  return sortBy !== undefined && order !== undefined
    ? {
      sort: order,
      sortBy: sortBy
    }
    : undefined
}

function reduceFilters(extras: any) {
  const finalExtras = extras !== undefined
    ? Object.keys(extras)
      .filter((key) => key !== 'criticalMomentId' && key !== 'parseFilters')
      .reduce((obj, key) => {
        let value = extras[key]

        if (value !== undefined && value !== null) {
          return Object.assign(obj, { [key]: value, })
        }

        return obj
      }, {})
    : extras

  return {
    ...finalExtras,
    ...parseSort(finalExtras)
  }
}

export const parseExtraFiltersIndicators = (extras: any) => {
  var extraFilters = reduceFilters(extras)

  if (extras?.status === 'EXTERNAL_SOURCE') {
    extraFilters = {
      ...extraFilters,
      criticalMomentInclude: undefined
    }
  }

  if (extras !== undefined && extras.parseFilters !== undefined) {
    return extras.parseFilters(extraFilters)
  }

  return extraFilters
}

/**
 * Parse the filters names and formats.
 * @param {Object} filters
 * @returns {Object}
 */
export const parseFiltersIndicators = (filters: FiltersUI, extras?: any): Filters => {
  const {
    includesFilterGeo,
    includesFilterLogical,
    includesFilterCriticalMoment,
    includesFilterChannel,
    includesFilterDynamic,
    includesFilterTimeBand
  } = useClientConfig()
  //console.log(`Parsing filters indicator `)
  //console.log(filters)
  //console.log(extras)

  const newExtras = reduceFilters(extras)

  if (!filters) {
    return {}
  }

  const dates = {
    dateFrom: dayjs(filters.fromDate).format('YYYY-MM-DD'),
    dateTo: dayjs(filters.toDate).format('YYYY-MM-DD'),
  }

  const clear = (filters: FiltersUI): Filters => {
    const safetyFilters = [
      'groupByTopLocation',
      'alertStatusInclude',
      'alertStatus',
      'alertTypeInclude',
      'status',
      'nullableLocations'
    ]
    return _.pick(filters, safetyFilters)
  }

  const responseValues = {}
  if (includesFilterDynamic([]) || extras?.extraResponseValues) {
    var rvs = {}

    if (includesFilterDynamic([]) && filters.responseValues !== undefined) {
      rvs = { ...rvs, ...filters.responseValues }
    }

    if (extras && extras.extraResponseValues) {
      rvs = { ...rvs, ...extras.extraResponseValues }
    }

    responseValues['responseValues'] = Object.keys(rvs).length > 0 ? rvs : undefined
  }

  // Critical Moments
  const criticalMomentInclude =
    extras !== undefined
      && extras.criticalMomentId !== undefined
      ? [extras.criticalMomentId]
      : (filters.criticalMoments !== undefined
        && filters.criticalMoments !== null
        && filters.criticalMoments.length > 0
        ? filters.criticalMoments
        : undefined)

  const criticalMomentFilters = includesFilterCriticalMoment([])
    ? { criticalMomentInclude: criticalMomentInclude }
    : {}

  // Geo Locations
  const geoLocationFilters = includesFilterGeo([])
    ? {
      geoLocationInclude: filters.geographicDistributions
        ? filters.geographicDistributions
        : undefined
    }
    : {}

  // Logical Locations
  const logicalLocationFilters = includesFilterLogical([])
    ? {
      logicalLocationInclude: filters.logicalDistributions
        ? filters.logicalDistributions
        : undefined
    }
    : {}

  // Logical Locations
  const channelFilters = includesFilterChannel([])
    ? {
      channelInclude: filters.channels
        ? filters.channels
        : undefined
    }
    : {}

  // Time Band
  const timeBandFilters = includesFilterTimeBand([])
    ? {
      formattedTimeBandInclude: filters.formattedTimeBand
        ? filters.formattedTimeBand
        : undefined
    }
    : {}

  const finalFilters = {
    ...dates,
    ...clear(filters),
    ...criticalMomentFilters,
    ...geoLocationFilters,
    ...logicalLocationFilters,
    ...channelFilters,
    ...timeBandFilters,
    ...responseValues,
    ...newExtras,
  }
  //console.log(finalFilters)

  if (extras !== undefined && extras.parseFilters !== undefined) {
    return extras.parseFilters(finalFilters)
  }

  return finalFilters
}

export default parseFiltersIndicators
